/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import TypeStrings from "./TypeStrings";

export default class GoogleAnalytics
{
    public static readonly messageTimeout: number = 1000;

    public static ClickEvent(name: string): void
    {
        GoogleAnalytics.sendEvent('Click', { Category: 'Interaction', Name: name });
    }

    public static ToggleEvent(name: string, toggle: boolean): void
    {
        GoogleAnalytics.sendEvent('Toggle', { Category: 'Interaction', Name: name, Value: toggle ? 1 : 0 });
    }

    public static SlideEvent(name: string): void
    {
        GoogleAnalytics.sendEvent('Slider', { Category: 'Interaction', Name: name });
    }

    public static SpinEvent(isLandscape: boolean): void
    {
        GoogleAnalytics.sendEvent('WagerMade', { Category: 'Game', Name: 'WagerMade', Value: isLandscape ? 0 : 1 })
    }

    // tslint:disable:no-string-literal
    private static sendEvent(event: string, option: IGAOptions): void
    {
        let gtag: any = window['gtag'];

        if (!gtag || typeof(gtag) !== TypeStrings.function) { return; }

        let eventParameter: IGAEventParameter =
        {
            event_category: option.Category,
            event_label: option.Name,
            value: option.Value
        };

        setTimeout(() =>
        {
            gtag('event', event, eventParameter);
        }, GoogleAnalytics.messageTimeout);
    }
}

interface IGAOptions
{
    Category: string;
    Name: string;
    Value?: number | any;
}

interface IGAEventParameter
{
    event_category: string;
    event_label: string;
    value?: number;
}
